import React, { useEffect, useState } from 'react';
import { apiRequest } from '../api/client';

interface CountryOption {
  id: string;
  name: string;
  iso2: string;
}

interface CountrySelectProps {
  token?: string; // kept for API compatibility, no longer used internally
  value: string; // country UUID or ''
  onChange: (countryId: string) => void;
  label?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({ value, onChange, label = 'Country', style, className }) => {
  const [countries, setCountries] = useState<CountryOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    apiRequest<CountryOption[]>('/api/v1/dashboard/countries')
      .then(setCountries)
      .catch(() => setError('Failed to load countries'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={style}>
      {label && <label style={{ fontWeight: 500, fontSize: '0.95rem', marginBottom: 4, display: 'block' }}>{label}</label>}
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={loading}
        className={className}
      >
        <option value="">All Countries</option>
        {countries.map(c => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>
      {error && <div style={{ color: 'var(--ds-danger-text)', fontSize: '0.85rem', marginTop: 4 }}>{error}</div>}
    </div>
  );
};
